export const patientDataError = [
  {
    path: '/nao-encontrei-meu-numero',
    name: 'irregular-phone-number',
    component: () => import('@/views/conclusion/GenericServiceDesk.vue'),
    meta: {
      reason: 'phone number not found',
      header: {
        title: 'Numero de telefone',
        hidePreviousBtn: true,
      },
    },
  },
  {
    path: '/nao-encontrei-meu-numero',
    name: 'irregular-phone-number-mobile-service',
    component: () => import('@/views/conclusion/GenericServiceDesk.vue'),
    meta: {
      reason: 'phone number not found',
      header: {
        title: 'Numero de telefone',
        hidePreviousBtn: true,
      },
      body: {
        title: 'Seu atendimento será finalizado pelo nosso time no dia do seu agendamento.',
        btnLabel: 'Ok, entendi',
        config: {
          showName: false,
          showSubtitle: false,
          showList: false,
        }
      }
    },
  },
  {
    path: '/servico-indisponivel',
    name: 'servico-indisponivel',
    component: () => import('@/views/conclusion/GenericServiceDesk.vue'),
    meta: {
      publicRoute: true,
      disabledPageReloadGuard: true,
      reason: 'MDM Service Unavailable',
      header: {
        title: 'Serviço indisponível',
      },
      body: {
        title: 'Serviço temporariamente indisponível',
        subtitle: 'Continue seu atendimento pelo guichê ou tente novamente mais tarde.',
        btnLabel: 'Finalizar atendimento',
        config: {
          showName: false,
          showList: false,
        }
      }
    },
  }
];
